export const PAGE_SIZE_OPTIONS = [
    { value: 50, label: '50 Keys' },
    { value: 100, label: '100 Keys' },
    { value: 200, label: '200 Keys' },
    { value: 500, label: '500 Keys' }
];

export const getFilterCounterText = (count) => `${count} ${count === 1 ? 'match' : 'matches'}`;